// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IModuleI18n } from '@platform/core/types/modularity/IModuleI18n';
import type { IModuleManifest } from '@platform/core/types/modularity/IModuleManifest';

/** Пакет модуля «Бізнес-аналіз» (Business Analysis, ключ `ba`, група `meta`). */
export const businessAnalysisManifest: IModuleManifest = {
  key: 'ba',
  group: 'meta',
  slug: 'business-analysis',
  prefix: 'BA',
  name: { en: 'Business Analysis', uk: 'Бізнес-аналіз' },
  entities: [
    { key: 'ba', slug: 'ba', name: { en: 'Business Analysis', uk: 'Бізнес-аналіз' }, main: true },
    { key: 'trace_link', slug: 'trace-link', name: { en: 'Trace Links', uk: 'Зв’язки простежуваності' }, main: false },
    { key: 'acceptance_test', slug: 'acceptance-test', name: { en: 'Acceptance Tests', uk: 'Приймальні тести' }, main: false },
    { key: 'review', slug: 'review', name: { en: 'Reviews', uk: 'Перегляди' }, main: false },
  ],
  loadState: () => import('./state/businessAnalysisSlice').then((m) => m.businessAnalysisSlice),
  loadI18n: (lng) => (lng === 'uk' ? import('./i18n/uk.json') : import('./i18n/en.json')).then((m) => m.default as IModuleI18n),
  loadDefinition: () => import('./definition').then((m) => m.definition),
};
